module.exports = __webpack_public_path__ + "static/media/crash.e21da62b.ogg";